import * as React from 'react';

const CreateRoundIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 120 120" {...props}>
        <defs>
            <linearGradient
                id="create-round-illustration_svg__a"
                x1={35.96}
                y1={102.11}
                x2={84.79}
                y2={17.53}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#206953" stopOpacity={0.3} />
                <stop offset={1} stopColor="#206953" stopOpacity={0} />
            </linearGradient>
        </defs>
        <circle cx={60.29} cy={59.89} r={48.73} fill="#59c3a3" />
        <circle
            cx={60.38}
            cy={59.82}
            r={48.82}
            fill="url(#create-round-illustration_svg__a)"
        />
        <path
            d="M80.59 78H11.83c-1.58 0-3.26-1.78-3.75-4L8 73.58h76.4l-.08.36c-.48 2.24-2.15 4.06-3.73 4.06z"
            fill="#00acaf"
        />
        <path
            d="M18.42 20.18h55.8a1.47 1.47 0 011.47 1.47v38.77H16.95V21.65a1.47 1.47 0 011.47-1.47z"
            fill="#ccf7f6"
        />
        <path
            d="M83.11 74.64H9.43a1.43 1.43 0 01-1.16-2.26l8.63-12h58.74l8.63 12a1.43 1.43 0 01-1.16 2.26z"
            fill="#70e4e0"
        />
        <path
            d="M74.7 69.1H17.85c-.9 0-1.83-.53-1.6-.93l3-5a2.06 2.06 0 011.75-.74h50.53a2.06 2.06 0 011.82.79l3 5c.18.35-.76.88-1.65.88z"
            fill="#00acaf"
        />
        <rect
            x={20.01}
            y={23.6}
            width={52.61}
            height={33.39}
            rx={0.91}
            ry={0.91}
            fill="#70e4e0"
        />
        <path
            d="M36.63 23.6h34.29a1.71 1.71 0 011.71 1.71v30A1.71 1.71 0 0170.92 57h-.86z"
            fill="#70e4e0"
        />
        <path
            fill="#ccf7f6"
            d="M57.09 74.64H35.55l3.46-5.52h14.62l3.46 5.52z"
        />
        <path fill="#ccf7f6" opacity={0.8} d="M23 27.09h46.67v29.94H23z" />
        <path
            fill="#00d8d2"
            d="M22.96 26.97h46.72v15.28H22.96zM25.67 44.54h21.2v1.67h-21.2zM25.67 48.03h14.45v1.67H25.67z"
        />
        <path
            d="M74.09 106.57l4.21-12s1.93 5.12 3.26 9.08c0 0 9.66-5.56 12.93-8.94l-3-8.49A22 22 0 0098.67 79a1.28 1.28 0 011.71-.43l.15.07a1.28 1.28 0 001.77-.52 26.52 26.52 0 002.91-10.79 1.55 1.55 0 00-1.45-1.46 1.28 1.28 0 01-1.28-1.22A22.81 22.81 0 0099.91 55a1.28 1.28 0 01.09-1.3l.58-.35a1.28 1.28 0 00.43-1.8 26.47 26.47 0 00-4.11-4.86 26.76 26.76 0 00-3.9-3.1 1.28 1.28 0 00-1.81.42 1.28 1.28 0 01-1.71.48 21.87 21.87 0 00-9.76-2.61c-.51 0-10.11-1.37-13.38.32a1.28 1.28 0 00-.55 1.8v.05a1.28 1.28 0 01-.42 1.71 22.34 22.34 0 00-7.12 7.12 1.28 1.28 0 01-1.72.43 1.28 1.28 0 00-1.78.52 26.52 26.52 0 00-2.88 10.8 1.26 1.26 0 00.45 1 1.28 1.28 0 00.94.41h.42a1.27 1.27 0 01.77 1.11 21.54 21.54 0 002.61 9.74 1.28 1.28 0 01-.49 1.71 1.28 1.28 0 00-.43 1.81 27.92 27.92 0 008 8l.16.09-6.93 19.85s12.42.05 16.72-1.78z"
            fill="#282c35"
            opacity={0.1}
        />
        <path
            d="M64 81.45l13.24 4.62a.61.61 0 01.38.78l-11.41 32.74a.61.61 0 01-1.1.11L61 112.56a.61.61 0 00-.75-.26l-7.58 3a.61.61 0 01-.8-.77l11.39-32.71a.61.61 0 01.74-.37z"
            fill="#f16932"
        />
        <path
            d="M86.75 81.45l-13.23 4.62a.61.61 0 00-.38.78l11.44 32.74a.61.61 0 001.1.11l4.14-7.14a.61.61 0 01.75-.26l7.58 3a.61.61 0 00.8-.77L87.53 81.82a.61.61 0 00-.78-.37z"
            fill="#f16932"
        />
        <path
            d="M49 63.38a26.52 26.52 0 012.88-10.8 1.28 1.28 0 011.78-.52 1.28 1.28 0 001.72-.43 22.34 22.34 0 017.12-7.12 1.28 1.28 0 00.42-1.71v-.05A1.28 1.28 0 0163.4 41a26.47 26.47 0 0110.83-2.9 1.28 1.28 0 011.33 1.27 1.28 1.28 0 001.22 1.27 21.87 21.87 0 019.76 2.61 1.28 1.28 0 001.71-.48 1.28 1.28 0 011.81-.42 26.79 26.79 0 017.94 7.9 1.28 1.28 0 01-.43 1.81 1.28 1.28 0 00-.5 1.7 22.81 22.81 0 012.6 9.72 1.28 1.28 0 001.28 1.22 1.28 1.28 0 011.24 1.3 26.49 26.49 0 01-2.9 10.83 1.28 1.28 0 01-1.76.53 1.28 1.28 0 00-1.71.43 22 22 0 01-7.13 7.11 1.28 1.28 0 00-.43 1.72 1.28 1.28 0 01-.52 1.77 26.49 26.49 0 01-10.79 2.88A1.28 1.28 0 0175.58 90a1.28 1.28 0 00-1.22-1.28 22.19 22.19 0 01-9.72-2.6 1.28 1.28 0 00-1.69.49 1.28 1.28 0 01-1.81.43 26.79 26.79 0 01-7.9-7.89 1.28 1.28 0 01.43-1.81 1.28 1.28 0 00.49-1.71 21.54 21.54 0 01-2.61-9.74 1.28 1.28 0 00-1.28-1.22A1.28 1.28 0 0149 63.38z"
            fill="#f58729"
        />
        <path
            d="M50.38 64.82a1.28 1.28 0 01-1.28-1.33 26.52 26.52 0 012.9-10.8 1.28 1.28 0 011.78-.52l22.6 12.66z"
            fill="#f9a51f"
        />
        <path
            d="M62.91 42.79a1.28 1.28 0 01.5-1.79 26.52 26.52 0 0110.78-2.94 1.28 1.28 0 011.34 1.27L76 65.27z"
            fill="#f9a51f"
        />
        <path
            d="M88.33 42.95a1.28 1.28 0 011.79-.45 26.52 26.52 0 018 7.84 1.28 1.28 0 01-.43 1.8l-22.23 13.4z"
            fill="#f9a51f"
        />
        <path
            d="M101.07 64.84a1.28 1.28 0 011.27 1.34A26.52 26.52 0 0199.45 77a1.28 1.28 0 01-1.78.51l-22.6-12.76z"
            fill="#f9a51f"
        />
        <path
            d="M88.36 86.78a1.28 1.28 0 01-.52 1.77 26.52 26.52 0 01-10.79 2.89 1.28 1.28 0 01-1.34-1.28l-.31-25.92z"
            fill="#f9a51f"
        />
        <path
            d="M63 86.73a1.28 1.28 0 01-1.8.43 26.52 26.52 0 01-7.87-7.93 1.28 1.28 0 01.45-1.8l22.35-13.14z"
            fill="#f9a51f"
        />
        <circle cx={75.7} cy={64.72} r={17.58} fill="#fdcd08" />
        <circle cx={75.58} cy={64.72} r={13.66} fill="#f9a51f" />
    </svg>
);

CreateRoundIllustrationSvg.displayName = 'CreateRoundIllustrationSvg';
export default CreateRoundIllustrationSvg;
